<template>
  <b-container class="py-3">
    <div class="my-3">
      <b-input-group prepend="Your Address">
        <b-form-input
          class="text-left"
          type="text"
          placeholder="Wallet address"
          v-model="landAddr"
        ></b-form-input>
        <b-input-group-append>
          <b-button @click.prevent="onLand" class="px-5" variant="info">
            Check
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <div v-if="land" class="my-2">
        <h3 class="mb-2">
          Your land: <b>{{ land.name }}</b>
        </h3>
        <div class="d-flex">
          <div
            class="w-25 text-center"
            v-for="(it, inx) in land.title"
            :key="it"
          >
            <div class="text-uppercase">{{ it }}</div>
            <div>{{ land.props[inx] }}</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <b-form-group label="KuniSaru:" v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          id="checkbox-kuni-1"
          v-model="selected"
          :options="saruList"
          :aria-describedby="ariaDescribedby"
          name="ck-saru-1"
        >
        </b-form-checkbox-group>
      </b-form-group>
      <b-input-group prepend="$KUNI (Ether)" class="mt-3">
        <b-form-input
          class="text-right"
          type="number"
          :placeholder="utils.bigToCommon(balance, 18, 2)"
          v-model="akuni"
        ></b-form-input>
        <b-input-group-append>
          <!-- <b-button class="px-3" variant="outline-success" @click="onMax"
            >MAX</b-button
          > -->
          <b-button
            class="px-5"
            variant="success"
            @click="onStaked"
            :disabled="selected.length === 0 && this.kuni == 0"
            >Stake</b-button
          >
        </b-input-group-append>
      </b-input-group>
      <b-input-group prepend="Rate" class="mt-3">
        <b-form-input
          max="100"
          class="text-right"
          type="number"
          placeholder="xxxx.00"
          v-model="rate"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            class="px-4"
            :disabled="selected.length === 0"
            variant="warning"
            @click.prevent="onScholar"
            >Scholarship</b-button
          >
        </b-input-group-append>
      </b-input-group>
    </div>
    <div class="mt-3 d-flex flex-column" v-if="stakedList.length > 0">
      <div>
        <strong>$Kuni Staked: </strong
        >{{ utils.bigToCommon(kuniStaked, 18, 2) }}
      </div>
      <b-form-group label="Kuni Staked:" v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          id="checkbox-stake-1"
          v-model="stakedSelected"
          :options="stakedList"
          :aria-describedby="ariaDescribedby"
          name="ck-stake-1"
        >
        </b-form-checkbox-group>
      </b-form-group>
      <b-input-group prepend="$Kuni Staked (Ether)" class="mt-3">
        <b-form-input
          class="text-right"
          type="number"
          :placeholder="utils.bigToCommon(balance, 18, 2)"
          v-model="kuni"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            class="px-3"
            variant="info"
            @click="onWithdrawTokens"
            :disabled="stakedSelected.length === 0"
            >Withdraw</b-button
          >
          <b-button @click.prevent="onWithdaw" class="px-3" variant="success">
            Withdraw All
          </b-button>
          <b-button @click.prevent="onClaim" class="px-3" variant="light">
            Claim
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div class="mt-3 d-flex flex-column">
      <b-form-group label="Kuni Scholarship:" v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          id="checkbox-scholar-1"
          v-model="scholarSelected"
          :options="scholarList"
          :aria-describedby="ariaDescribedby"
          name="ck-scholar-1"
        >
        </b-form-checkbox-group>
      </b-form-group>
      <b-button
        variant="info"
        class="px-5"
        @click="onCancel"
        :disabled="scholarSelected.length === 0"
        >Cancel Scholaship</b-button
      >
      <b-input-group prepend="New Owner" class="mt-3">
        <b-form-input
          class="text-left"
          v-model="newOwner"
          placeholder="new Owner 0x...."
        ></b-form-input>
        <b-input-group-append>
          <b-button
            @click.prevent="onTransferOwner"
            class="px-3"
            variant="info"
            :disabled="scholarSelected.length == 0"
          >
            Transfer Owner Scholarship
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
  </b-container>
</template>
<script>
import { NFT, ERC20, Scholarship, CoreGame } from "@/amakunicom/sdk";
import { ethers } from "ethers";
export default {
  name: "game-tool",
  data: () => ({
    selected: [],
    saruList: [],
    stakedSelected: [],
    stakedList: [],
    scholarSelected: [],
    scholarList: [],
    rate: 50,
    landAddr: "",
    newOwner: "",
    kuni: ethers.constants.Zero,
    balance: ethers.constants.Zero,
    kuniStaked: ethers.constants.Zero,
    akuni: "",
    land: null,
  }),
  async created() {
    this.signer = await this.provider.getSigner();
    this.account = await this.signer.getAddress();
    this.tokens = this.getCoreConfig();
    this.tKuni = new ERC20(this.tokens.kuni, this.provider, this.signer);
    this.saru = new NFT(this.tokens.kuniSaru, this.provider, this.signer);
    this.item = new NFT(this.tokens.kuniSaru, this.provider, this.signer);
    this.scholar = await Scholarship.initWith(
      this.tokens.scholarship,
      this.provider,
      this.signer
    );
    this.game = new CoreGame(this.tokens, this.provider, this.signer);
    this.fetchNft();
    this.fetchScholar();
    this.fetchStaked();
    this.balance = await this.tKuni.balanceOf(this.account);
  },
  methods: {
    onMax() {
      this.kuni = this.balance;
    },
    async fetchNft() {
      const { data } = await this.saru.tokenIdsOf(this.account);
      this.saruList = data.map((value) => ({ text: `#${value}`, value }));
    },
    fetchScholar() {
      const self = this;
      this.scholar.contract
        .valuesOf(this.tokens.kuniSaru, this.account)
        .then((rs) => {
          self.scholarList = rs.map((value) => ({ text: `#${value}`, value }));
        });
    },
    fetchStaked() {
      const self = this;
      this.game.stakedInfo(this.account).then(([list, kuniStaked]) => {
        self.stakedList = list.map((value) => ({ text: `#${value}`, value }));
        self.kuniStaked = kuniStaked;
      });
    },
    async onScholar() {
      await (
        await this.scholar.ask(
          this.tokens.kuniSaru,
          this.account,
          this.selected,
          ethers.utils.parseUnits(`${this.rate}`, 2)
        )
      ).wait();
      this.onSuccess();
      this.fetchScholar();
      this.fetchNft();
    },
    async onStaked() {
      await this.tKuni.approve(this.account, this.tokens.amaGame);
      await this.saru.checkAndApprove(this.account, this.tokens.amaGame);
      await (
        await this.game.contract.deposit(
          ethers.utils.parseEther(`${this.akuni}`),
          this.selected
        )
      ).wait();
      this.selected = [];
      this.onSuccess();
      this.fetchNft();
      this.fetchStaked();
    },
    async onClaim() {
      await (await this.game.contract.claim()).wait();
      this.onSuccess();
    },
    async onCancel() {
      await (
        await this.scholar.cancel(this.tokens.kuniSaru, this.scholarSelected)
      ).wait();
      this.onSuccess();
      this.fetchScholar();
      this.fetchNft();
    },
    async onWithdaw() {
      await (await this.game.contract.withdraw()).wait();
      this.onSuccess();
      this.fetchNft();
      this.fetchStaked();
    },
    async onWithdrawTokens() {
      await (
        await this.game.withdrawTokens(this.kuniStaked, this.stakedSelected)
      ).wait();
      this.onSuccess();
      this.fetchNft();
      this.fetchStaked();
    },
    onLand() {
      this.land = this.utils.getLandInfo(this.landAddr);
    },
    async onTransferOwner() {
      try {
        await this.scholar.contract.transferOwner(
          this.tokens.kuniSaru,
          this.scholarSelected,
          this.newOwner
        );
        this.$bvToast.toast("successful!");
      } catch (err) {
        this.$bvToast.toast(
          err.reason || err.message || "KUNI: Unable to process request",
          {
            variant: "warning",
            autoHideDelay: 2000,
            title: "Warning",
          }
        );
      }
    },
    onSuccess() {
      this.$bvToast.toast("Transaction Successfully!", {
        autoHideDelay: 2000,
        variant: "success",
        title: "Successfully!",
      });
    },
  },
};
</script>
